import LampiranI from './LampiranI';

export default LampiranI